import { render, staticRenderFns } from "./downStream.vue?vue&type=template&id=1a016b46&scoped=true&"
import script from "./downStream.vue?vue&type=script&lang=js&"
export * from "./downStream.vue?vue&type=script&lang=js&"
import style0 from "./downStream.vue?vue&type=style&index=0&id=1a016b46&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a016b46",
  null
  
)

export default component.exports